import { useCallback, useMemo } from 'react';
import { getMCDEnabled } from '../remoteComponents/../authService'; // Adjust path if needed
import { ProfileStandardClaims } from 'oidc-client';

export interface AuthDataHook {
  token: string;
  profile: ProfileStandardClaims | undefined;
}
export function useAuthData(): AuthDataHook {
  const environmentVariables: any = (window as any).ENV || {};
  const hstName = window.location.href;

  const getClientId = useCallback((): string => {
    const isMCDSSO =
      window.location.pathname.includes('mcd') ||
      getMCDEnabled(window.location.search) ||
      environmentVariables.MCD_INSTANCE ||
      ((window as any).ENV?.ADMIN_MCD_HOSTNAME
        ? hstName.includes((window as any).ENV.ADMIN_MCD_HOSTNAME)
        : false);

    if (isMCDSSO) {
      return `${environmentVariables.AUTHORITY}:${environmentVariables.AUTHORITY_CLIENT_ID_MCD}`;
    }
    if (localStorage.getItem('selectedLoginOption') === 'SSO') {
      return `${environmentVariables.AUTHORITY_HON_SSO}:${environmentVariables.AUTHORITY_CLIENT_ID_HON_SSO}`;
    }
    return `${environmentVariables.AUTHORITY}:${environmentVariables.AUTHORITY_CLIENT_ID}`;
  }, [environmentVariables, hstName]);

  const getAccessToken = useCallback((): string => {
    try {
      const raw = sessionStorage.getItem(`oidc.user:${getClientId()}`);
      if (!raw) return '';
      const parsed = JSON.parse(raw || '{}');
      return parsed?.access_token || '';
    } catch {
      return '';
    }
  }, [getClientId]);

  const getProfile = useCallback((): ProfileStandardClaims | undefined => {
    try {
      const raw = sessionStorage.getItem(`oidc.user:${getClientId()}`);
      if (!raw) return undefined;
      const parsed = JSON.parse(raw || '{}');
      return parsed?.profile;
    } catch {
      return undefined;
    }
  }, [getClientId]);

  const token = useMemo(() => getAccessToken(), [getAccessToken]);
  const profile = useMemo(() => getProfile(), [getProfile]);

  return { token, profile };
}

export default useAuthData;